import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 10C0 4.47715 4.47715 0 10 0H54C59.5228 0 64 4.47715 64 10V54C64 59.5228 59.5228 64 54 64H10C4.47715 64 0 59.5228 0 54V10Z"
      className="bgColor"
    />
    <path
      d="M20.6286 30.2136C20.1505 29.7355 19.9113 29.0686 19.9765 28.3956L20.5408 22.5743C20.6452 21.4974 21.4974 20.6452 22.5743 20.5408L28.3956 19.9765C29.0686 19.9113 29.7355 20.1505 30.2136 20.6286L35.1653 25.5803C36.0488 26.4637 36.0488 27.8961 35.1653 28.7796L28.7797 35.1652C27.8962 36.0487 26.4638 36.0487 25.5803 35.1652L20.6286 30.2136Z"
      className="bgColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.3654 26.3801L29.4137 21.4284C29.1747 21.1894 28.8413 21.0698 28.5048 21.1024L22.6834 21.6667C22.145 21.7189 21.7189 22.145 21.6667 22.6834L21.1024 28.5047C21.0698 28.8412 21.1894 29.1747 21.4284 29.4137L26.3801 34.3654C26.8219 34.8071 27.5381 34.8071 27.9798 34.3654L34.3654 27.9798C34.8072 27.538 34.8072 26.8218 34.3654 26.3801ZM19.9765 28.3956C19.9113 29.0686 20.1505 29.7355 20.6286 30.2136L25.5803 35.1652C26.4638 36.0487 27.8962 36.0487 28.7797 35.1652L35.1653 28.7796C36.0488 27.8961 36.0488 26.4637 35.1653 25.5803L30.2136 20.6286C29.7355 20.1505 29.0686 19.9113 28.3956 19.9765L22.5743 20.5408C21.4974 20.6452 20.6452 21.4974 20.5408 22.5743L19.9765 28.3956Z"
      className="mainColor"
    />
    <path
      d="M27.5616 29.6465C27.1198 29.2048 27.1198 28.4886 27.5616 28.0468L28.0456 27.5628C28.4873 27.1211 29.2035 27.1211 29.6453 27.5628L34.7134 32.631C35.1551 33.0727 35.1551 33.7889 34.7134 34.2306L34.2294 34.7147C33.7876 35.1564 33.0714 35.1564 32.6297 34.7147L27.5616 29.6465Z"
      className="bgColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.8454 28.3627L28.3614 28.8467L33.4295 33.9148L33.9135 33.4308L28.8454 28.3627ZM27.5616 28.0468C27.1198 28.4886 27.1198 29.2048 27.5616 29.6465L32.6297 34.7147C33.0714 35.1564 33.7876 35.1564 34.2294 34.7147L34.7134 34.2306C35.1551 33.7889 35.1551 33.0727 34.7134 32.631L29.6453 27.5628C29.2035 27.1211 28.4873 27.1211 28.0456 27.5628L27.5616 28.0468Z"
      className="mainColor"
    />
    <path
      d="M32.5635 36.3145C32.1218 35.8727 32.1218 35.1565 32.5635 34.7148L34.7145 32.5638C35.1562 32.1221 35.8724 32.1221 36.3142 32.5638L42.8072 39.0569C43.843 40.0926 43.843 41.7719 42.8072 42.8076C41.7715 43.8433 40.0923 43.8433 39.0566 42.8076L32.5635 36.3145Z"
      className="bgColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.5143 33.3637L33.3634 35.5146L39.8564 42.0077C40.4504 42.6017 41.4134 42.6017 42.0074 42.0077C42.6014 41.4138 42.6014 40.4507 42.0074 39.8568L35.5143 33.3637ZM32.5635 34.7148C32.1218 35.1565 32.1218 35.8727 32.5635 36.3145L39.0566 42.8076C40.0923 43.8433 41.7715 43.8433 42.8072 42.8076C43.843 41.7719 43.843 40.0926 42.8072 39.0569L36.3142 32.5638C35.8724 32.1221 35.1562 32.1221 34.7145 32.5638L32.5635 34.7148Z"
      className="mainColor"
    />
  </svg>
);

const EnhancementsIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default EnhancementsIcon;
